import { PagePending } from "@/components/ui/PagePending";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { fallback, object, optional, string } from "valibot";

export const Route = createFileRoute("/supporter/$supporterId/allowance-reports/utilisation")({
  pendingComponent: PagePending,
  validateSearch: object({
    // Name of the selected historical date range (see createHistoricalDateRanges).
    range: fallback(optional(string()), undefined),
  }),
  component: lazyRouteComponent(() => import("./+Utilisation")),
});
